export default __webpack_public_path__ + "static/media/avatar.0d8ed694.png";